import { useContext } from 'react';
import { UseContentProps } from '../types';
import { HomepageProps } from '../views/Homepage/Homepage';
import { HomepagePropsContext } from '../context/HomepagePropsProvider';

export const useHomepageProps = (): UseContentProps<HomepageProps> => {
  const context = useContext(HomepagePropsContext);
  if (context === undefined || context === null) {
    throw new Error('useHomepageProps must be used within a HomepagePropsProvider');
  }

  return context;
};
